module.exports = __webpack_public_path__ + "static/media/ic-good-sel.143ed9a9.svg";